// Mirrors the backend ScreenId enum (backend-audio common/frontend/ScreenId.php) — the value is the
// wire contract between the two, and nothing else. It is deliberately NOT the analytics screen name:
// `analytics/constants/screenNames` maps id → name, because one reported screen can cover several
// product screens (and the reported names are fixed by the existing dataset).
//
// New ids are kebab-case. The `snake_case` ones below predate that and are left alone: changing an
// id means changing it in both repositories in the same release, which is not worth doing for
// cosmetics alone.
export enum ScreenId {
    MP3_CUTTER = 'mp3-cutter',
    ERROR = 'error',
    AUDIO = 'audio',
    AUTH = 'auth',
    FORGOT_PASSWORD = 'forgot_password',
    BROWSE = 'browse',
    COLLECTION = 'collection',
    SEARCH = 'search',
    USER_AUDIO = 'user_audio',
    USER_COLLECTIONS = 'user_collections',
    AUDIO_UPLOAD = 'audio-upload',
    AUDIO_EDIT = 'audio-edit',
    AUDIO_NOT_FOUND = 'audio-not-found',
}
